module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.0.0.box.274.418.1156.398.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.16.0.0.box.1370.418.60.102.q.60"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center",
      "font-variant": "small-caps"
    },
    attrs: {
      "id": "para.16.0.1.box.274.690.878.126.q.100"
    }
  }, [_vm._v("Spanish Period")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.270.1078.1157.1233.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.16.1.0.box.452.1078.804.99.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.0.0"
    }
  }), _vm._v("DOMINGO TERAN DE LOS RIOS "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1691-1692) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.272.1242.1155.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.1.0"
    }
  }), _vm._v("Domingo Teran de los Rios, the first Spanish governor of the newly created province of Texas, was an unhappy, frustrated man from start to finish of his administration. He had no reason to expect this, for he had long proven himself in the king's service. He had already been a governor for over three years—of Sonora and Sinaloa—and had served the king in Peru for twenty years before coming to Mexico in 1681, as deputy to the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("consulado ")]), _vm._v("of Sevilla and then as captain of infantry in the Castle of Sevilla.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.271.1728.1156.366.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.2.0"
    }
  }), _vm._v("His commission, dated January 23, 1691, provided a handsome salary of twenty-five hundred pesos a year and a virtually unlimited territory to rule—\"Tejas and adjacent regions.\" He might explore, conquer, and rule all the Gulf Coast to the Atlantic Ocean, for in general he was instructed to get all Frenchmen out of the region and strengthen it so they could not come back.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA7.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.3.box.270.2106.1154.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA7.w.2.3.0"
    }
  }), _vm._v("Alonso de Leon, governor of Coahuila, had already found the ruins of La Salle's fort and burned them and then established the mission of San Francisco de los Tejas, near the present village of Weches in Houston County."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.1.0.box.270.388.1154.154.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.0.0"
    }
  }), _vm._v("\nThough De Leon found no colony, the very idea of Frenchmen in the region had the Spaniards in a state of jitters.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.270.388.1157.1885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.1.box.271.552.1152.425.q.60"
    }
  }, [_vm._v("Teran seemingly faced all the prospects for glory a man could want. But instead, just about everything bad that could happen to a governor in primitive Texas did. In the first place, he received a force of only fifty soldiers, along with ten missionaries and three lay brothers. He protested to his superiors and to Father Fray Damian Mar sanet, heading the missionaries, that his force was inadequate, but neither paid any attention to him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.2.box.272.987.1155.473.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.2.0"
    }
  }), _vm._v("The expedition left Monclova on May 16, 1691, and headed for the mission of San Francisco. On the way they failed to find supplies and reinforcements on the Gulf Coast that were expected by sea. Teran hesitated, saying they were essential, but Father Massanet would not hear this. And he promptly cited royal orders to His Excellency stating that the establishing of missions was the purpose of the expedition and that no action was to be taken without his approval, thus reducing Teran to a mere governor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.3.box.273.1470.1154.532.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.3.0"
    }
  }), _vm._v("So the eternal fly in the administrative ointment was Father Massanet, bent on saving the souls of the savages without delay, come timid, incompetent governors or tomahawks. He was as stubborn and fearless as they came, trusting only in God for protection that the military thought required gunpowder. So it was that the governor spent most of his administration riding over his domain on a poor horse and living in the open, mainly on reduced rations, and much of that Indian fare. He never had a capitol.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA8.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.4.box.273.2014.1152.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA8.w.1.4.0"
    }
  }), _vm._v("The Tejas Indians were not overjoyed at seeing the Spaniards. Bell ringing and incense burning could not take their minds off a strange malady the last Spaniards left, and no amount of gourd rattling and ground stomping by the medicine man could drive it away. Being more visually"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.18.1.0.box.270.402.1155.261.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.0.0"
    }
  }), _vm._v("\nperceptive than biologically knowledgeable, the medicine man, ironically, diagnosed the malady as the evil effects of holy water rather than any indiscretions of the soldiers. Stealing horses obviously brought them more joy, and the promise of it, than hearing mass.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.270.402.1155.1890.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.270.674.1154.592.q.60"
    }
  }, [_vm._v("Seeing the futility of it all, Teran left Father Massanet to his Latin masses and frocked parades, and struck out for the Caddo tribe to see what the French were up to there. He found none. His mood urged him to go home by way of the Red River, but he could not find out if it was navigable, so he plodded back to the Tejas. He told Father Massanet he could stay as long as he wanted to, but he himself was heading back to Mexico. He helped himself to the mission horses over Massanet's screaming protest, saying the Indians would get them if he didn't, which was probably right.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.270.1276.1155.575.q.60"
    }
  }, [_vm._v("To make a long, disappointing story short, the mission failed miserably. It foretold a heroic, impractical pattern that the zealous, dedicated missionaries could never quite see through. The Spaniards thought that if they could save the souls of the Indians, they would have their support to save Texas from the land-greedy French, but in a century and a half of steadfast missionary effort, not a single Texas tribe was permanently converted to Christianity. The missionaries often used the military as a scapegoat, saying they did not provide adequate protection or that the soldiers did mischief.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.3.box.270.1872.1154.301.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.3.0"
    }
  }), _vm._v("Governor Teran was glad to escape any way he could. He made it to Bernardo Bay on March 5, 1692, where he received instructions from the viceroy to explore the Mississippi. He set out for the river but soon abandoned the project, he said, on account of bad weather, and sailed for Veracruz. And that is the last we hear of him in Texas.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA9.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.4.box.272.2195.1150.97.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA9.w.1.4.0"
    }
  }), _vm._v("His unfavorable report was doubtless the main reason the Spaniards abandoned the missionary effort in East"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.19.1.0.box.272.390.619.33.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA10.w.1.0.0"
    }
  }), _vm._v("\nTexas for the next two decades.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.19.1.0.box.272.390.619.33.q.70"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.19.2.0.box.270.554.1156.1710.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.19.2.0.box.565.554.569.95.q.80"
    }
  }, [_vm._v("MARTIN DE ALARCON "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.1.0"
    }
  }), _vm._v("(1716-1719) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.1.box.273.714.1151.360.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.2.0"
    }
  }), _vm._v("Martin de Alarcon's administration was a parallel in most respects to that of his predecessor. His main tasks were to establish missions and to keep the French in their place—wherever that was. He never had as many supplies and troops as he thought he needed, and like Teran, he had an impatient, touchy priest on his hands who wanted to boss and blame him for all failures.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.2.box.270.1095.1156.748.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.3.0"
    }
  }), _vm._v("Another French \"invasion\" had created renewed frantic effort to settle Texas. In late 1716 rumors in Mexico City made it sound as if the French were running all over the Texas province, doubtless looking for a place to settle. This time the French were invading by land instead of sea. An enterprising French trader named Louis Juchereau de St. Denis had established the French on the Red River at Natchitoches in 1714, and by mid-1716 had established trade with the Indians and Spaniards as far into the interior as the Rio Grande. After an interview with the viceroy in Mexico, he was employed as a guide to lead an expedition of Spaniards back east and establish them at Los Adaes, fifteen miles west of the French post at Natchitoches, for purpose of trade, from his point of view.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA10.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.19.2.3.box.273.1854.1153.410.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA10.w.2.4.0"
    }
  }), _vm._v("Alarcon was commissioned governor of \"Tejas and such other lands as he might conquer\" on December 8, 1716. With him came Father Antonio de San Buenaventura Olivares in charge of the religious. The records of the missionaries give one the idea that they were coming back to Christianize the Indians anyway, whether the French were there or not. But it was French incursions that roused the civil authorities to counteraction.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.20.1.0.box.270.402.1156.1887.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.0.box.271.402.1153.523.q.60"
    }
  }, [_vm._v("Olivares was old and impatient to get on with his work before it was too late. He was at San Juan Bautista by May 3, disgusted and complaining that the Ramon family in command there was \"more interested in smuggling\" than furnishing him supplies, and calling for Governor Alarcon to get on with his assignment. Alarcon finally arrived August 3, 1717. He agreed with Olivares about French smuggling, but that was about all. They had started a never-ending quarrel over prerogatives and the governor's slowness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.1.box.272.946.1154.478.q.60"
    }
  }, [_vm._v("By May, 1718, the Spaniards had founded a mission to be known as San Antonio de Valero and the Villa de Bejar. But to Olivares' disappointment, the Indians would not congregate. To try to stop the priest's growling and putting the blame on him, the governor said that if he wanted them in such a hurry he saw no way he could provide them other than to round them up with the sword. Bickering turned to insult when Olivares informed both the governor and the viceroy that he considered such methods stupid.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.2.box.271.1435.1154.482.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.2.0"
    }
  }), _vm._v("Alarcon at last arrived at the East Texas missions in November, 1718. The Indians had built a thatched hut for receiving the governor. They lifted him into it ceremoniously, fed him choice nuts and fruit, and danced about the old man with great animation, doubtless coached by the missionaries. The governor promptly wrote his superiors that the Indians were overjoyed to see him, which reveals that Father Olivares, though impetuous, knew something about politics, governors, and Indians.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA11.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.20.1.3.box.270.1927.1153.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA11.w.1.3.0"
    }
  }), _vm._v("At this time the Indians were almost destitute. They knew the governor had grain and trinkets in the bundles on his pack animals. Time was to prove they were much more uplifted by the sight of corn than the smell of incense, and took more comfort in gunpowder to protect themselves against their earthly enemies than in holy water to protect them against the devil.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.21.1.0.box.270.390.1159.1881.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.0.box.270.390.1156.423.q.60"
    }
  }, [_vm._v("Alarcon spent his time riding from mission to mission acting as godfather at baptisms, making long speeches to the Indians on the wonders of Spain and salvation, while they waited patiently for food and trinkets at the end. He wrote lengthy, monotonous reports to the viceroy on statistics of baptisms, number of friendly Indians under his jurisdiction, his desire to expand the dominion of the king, and his need for more troops to do it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.1.box.274.824.1153.574.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.1.0"
    }
  }), _vm._v("Having one concept of glory, he announced he was ready to drive the French from Natchitoches. The missionaries set off a loud protest. Did His Excellency not know that St. Denis himself, the commandant at Natchitoches, established the Spanish at Los Adaes? The French controlled the Indians on both sides of the border. They often lived with the Indians and married among them, while the Spanish missionary system was patronizing segregation in the extreme. The Indians appreciated the difference and responded in kind. Rile St. Denis and he might chase the whole lot of them back across the Rio Grande.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.2.box.274.1419.1155.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.2.0"
    }
  }), _vm._v("Considering Alarcon's experience, his subjects expected better of him. A soldier of fortune, he had seen service at Oran, and had been in the royal navy and a captain of infantry at Valencia. In Mexico he held numerous distinguished positions, such as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alcalde ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mayor ")]), _vm._v("of Tacona and Zamora, protector of Indians at Mazapil, and governor of Coahuila.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.3.box.273.1798.1153.257.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.3.0"
    }
  }), _vm._v("Alarcon saw the futility of many of his and the missionaries' efforts, and frustration plagued him. Old, tired, confused, disgusted, he told the missionaries so, as politely as his temper would permit, then wrote a letter of resignation to the viceroy in early 1719.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA12.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.21.1.4.box.272.2067.1152.204.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA12.w.1.4.0"
    }
  }), _vm._v("His resignation was promptly accepted, but it seems nothing ever worked out on schedule for Alarcon. He was kept in office until December. And for the next four years he fretted with officials, trying to collect part of his salary"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.22.1.0.box.273.402.1153.87.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  }), _vm._v("\nand expense account, until he became bitter as well as bewildered.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.22.1.0.box.273.402.1156.261.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.1.1.box.274.510.1155.153.q.60"
    }
  }, [_vm._v("In Texas, Alarcon never knew what it was all about, and the missionaries never let him get away with anything they did not approve of.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.22.2.0.box.270.782.1159.1504.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.22.2.0.box.337.782.1033.98.q.70"
    }
  }, [_vm._v("MARQUES DE SAN MIGUEL DE AGUAYO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1719-1722) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.1.box.270.947.1159.698.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.1.0"
    }
  }), _vm._v("In mid-1719 an event took place in Texas tailor-made for creating a hero: The French \"invaded\" Texas and \"drove\" the Spanish out of the eastern part. Nothing unites people like a common enemy, real or imagined. So the viceroy called up his best pedigreed man to recapture East Texas, a marquis, no less, whose family estate included almost half the state of Coahuila. His ancestors had fought and bled just about everywhere Spanish kings had bloody business to do. He was born in Spain and named Joseph de Azlor. He fought for the king there before coming to Coahuila in 1712. It was through his marriage to an heiress, Ignacia Xaviera, that he gained his title of Marques de Aguayo.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.22.2.2.box.271.1655.1157.631.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.2.2.0"
    }
  }), _vm._v("He was appointed governor and captain general of Coahuila and Texas in late 1719 after vowing to drive the French out of any territory claimed by Spain, even to the Mississippi River. Bales of paper have been inked about Aguayo's recapture of Texas and making it forever secure for Spain. Actually, the invasion of 1719 (while France and Spain were at war) was effected by an army of eight men who rode over from Natchitoches and captured a lay brother, one ragged soldier, a flock of chickens, and the ornaments and fixtures of the mission. Fluttering of the chickens spooked the commander's horse and it threw him. In the confusion, the lay brother escaped and ran"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.23.1.0.box.327.387.1152.141.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("\nacross Texas crying \"the French are coming\" so loudly that every cautious Spaniard fled to San Antonio or farther south.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.23.1.0.box.322.387.1157.1881.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.1.box.327.550.1150.207.q.60"
    }
  }, [_vm._v("Aguayo marched across the Rio Grande with the largest force ever to enter Texas, about five hundred men, along with four thousand horses and other livestock. He reached San Antonio on April 4, 1721.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.2.box.322.768.1156.533.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.2.0"
    }
  }), _vm._v("At the end of July, Aguayo met St. Denis waiting for him at the Neches River. Much propaganda has been written about this meeting. The Spaniards reported, in effect, that Aguayo, finding St. Denis without his reported army of Indians, told him if he would go quietly back to the Red River he wouldn't attack, at least not then. Pure rubbish! The Frenchman did not need Indians assembled. Just the fact that they were squatting in the brush all over the territory with St. Denis there was enough to scare the daylights out of any knowledgeable Spaniard.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.3.box.327.1312.1152.362.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.3.0"
    }
  }), _vm._v("Actually, St. Denis was there to welcome his customers back. He had just been granted a five percent commission on profits of merchandise sold to foreigners. He was glad to see so many of them. He apologized to Aguayo for that misunderstanding about a few of his men riding over to Los Adaes while he was away and the undue fright it caused. His Lordship was flabbergasted at such poise.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.23.1.4.box.324.1685.1153.583.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.4.0"
    }
  }), _vm._v("St. Denis rode back to Natchitoches. Aguayo brought his expedition to Los Adaes, reestablished the mission, and laid out a presidio. A few days after his arrival, St. Denis rode over to welcome him, bringing chickens for the governor's table along with melons and fresh vegetables. So the two commanders exchanged views, food, and liquor, and there was the crackle of charming conversation rather than exploding gunpowder. Aguayo wrote the viceroy that he had cleared Texas of all Frenchmen, and that there would be no trade with them. At the time, Aguayo's troops were living on bread made from French corn, and"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.24.1.0.box.306.402.652.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  }), _vm._v("\nSt. Denis ordered more drygoods.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.24.1.0.box.304.402.1154.694.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.1.box.305.453.1153.307.q.60"
    }
  }, [_vm._v("Aguayo's expedition has been grossly overrated. He did not gain a single foot of territory for Spain, and he did not stop French trade. He simply led the Spaniards back without opposition to the place they had run away from, and now both the French and Spanish were where they had been before the \"invasion.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.1.2.box.304.780.1153.316.q.60"
    }
  }, [_vm._v("Aguayo resigned in 1722, giving as reason ill health resulting from the hardships of the expedition. In 1724 he was.given the rank of field marshal by the king. He died March 7, 1734, and was buried in the chapel of Santa Maria de las Parras. The Texas expedition had brought Aguayo no glory, just fatigue and great expense.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.24.2.0.box.301.1216.1158.1067.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.24.2.0.box.459.1216.845.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _vm._v("FERNANDO PEREZ DE ALMAZAN "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("722-) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.1.box.303.1376.1156.481.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.1.0"
    }
  }), _vm._v("Fernando Perez de Almazan got the governorship of Texas mainly because he happened to be in the right place at the right time. And he held onto it longer than the average, doubtless because he had on-the-spot experience and had made some practical observations. He was lieutenant governor under Aguayo. When Aguayo, tired, sick, and outwitted by the French, threw in the towel in early 1722 and headed back toward Coahuila, he left Almazan in charge.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.24.2.2.box.301.1867.1154.416.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.2.0"
    }
  }), _vm._v("The best firsthand information about him comes from Aguayo's recommendation to the viceroy. He said no one was better able to carry out the \"reorganization\" of the province than Don Fernando, \"whose noble parentage, distinguished services, unquestioned ability, unselfish devotion to duty, and great zeal\" fitted him particularly for the position of governor. He said that he was well liked by the Indians, the soldiers had a high opinion of him, and the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.25.1.0.box.272.391.1150.86.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.0.0"
    }
  }), _vm._v("\nmissionaries looked upon his possible appointment with favor.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.25.1.0.box.271.391.1155.1878.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.1.box.271.498.1154.693.q.60"
    }
  }, [_vm._v("If any governor ever knew what to do right off, he should have. He had seen how Aguayo had worn himself out trying to prevent trade with the French while the Spanish population grew hungrier and more ragged. So he enforced no restrictions. The viceroy, in time, got wind of this and called his hand. The governor pleaded in response that due to crop failures, the long distances, and delays in transportation, the Spanish would suffer without trade. And the French had no priest at Natchitoches, so Spanish priests officiated there. The two nationalities helped each other. He was one of the few Spanish governors ever bold enough to tell a viceroy he thought it was a pretty good arrangement.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.2.box.273.1203.1151.246.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.2.0"
    }
  }), _vm._v("The viceroy promptly put his foot down on this, and Almazan replied that all intercourse between the two nations would cease at once. But there was no way for this distant wilderness outpost to live entirely alone, and he knew it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.3.box.272.1470.1154.427.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.3.0"
    }
  }), _vm._v("His disillusionment increased as he rode over his province from post to post. As a rule he found them undersupplied, undermanned, and incompetently administered, the Indians refusing to take to the plow and prayers, rebelling against congregating, and going on the warpath in some instances; the Apaches were especially troublesome. He had rafts built to ferry supplies, but when there were supplies the streams always seemed too high to cross.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA16.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.25.1.4.box.271.1906.1154.363.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.1.4.0"
    }
  }), _vm._v("In 1726 and 1727 he repeatedly wrote to the viceroy that he was sick, tired of his job, and wanted to quit. When the viceroy did nothing about it, he at last took matters into his own hands and appointed Melchor Mediavilla, captain of Los Adaes, as lieutenant governor. Mediavilla served as chief administrative officer in Texas probably more than three years, but the viceroy never sanctioned"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.26.1.0.box.274.403.1153.97.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  }), _vm._v("\nhis appointment. Thus historians do not list him as a true governor.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.26.1.0.box.273.403.1157.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.1.1.box.273.511.1157.314.q.60"
    }
  }, [_vm._v("The records are in conflict about the terminal date of Almazan's tenure. He spent some time in San Antonio and was in Mexico City by 1729. It seems that when he could not get officially relieved, he just rode off from the capitol at Los Adaes toward Mexico and slipped quietly out of the province.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.26.2.0.box.270.942.1161.1345.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.26.2.0.box.336.942.1038.101.q.70"
    }
  }, [_vm._v("JUAN ANTONIO BUSTILLO Y ZEVALLOS "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1731-1734?) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.2.1.box.274.1109.1157.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.1.0"
    }
  }), _vm._v("Juan Antonio Bustillo y Zevallos, the most practicalminded, youthful, and possibly the most cultured governor of Texas up to his time, was brave in the face of both Indians and viceroys. He added both the light touch and efficiency to Texas politics, diplomacy, and commerce. He came from one of the best-known and most cultured families of Spain, in the mountains of Burgos, and was a nobleman with the rank of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("hildago. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.2.2.box.270.1543.1159.530.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.2.0"
    }
  }), _vm._v("By the spring of 1725 he was commandant at La Bahia. When Rivera inspected the post, he reported it as the most efficiently administered in the province and recommended Bustillo for governor. Date of his commission is not certain, but he arrived at the Los Adaes capital April 28, 1731, driving ahead of him several hundred head of livestock and bringing probably the most supplies the post had ever seen at one time. By his own statement he was forty years old and had seen eight years of service in the province.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA17.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.26.2.3.box.271.2084.1155.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.3.0"
    }
  }), _vm._v("The French commandant at Natchitoches, St. Denis, knew of him and his coming. St. Denis' wife was a member of a ruling family in Mexico, and what the Indians didn't tell him about doings in Texas, his wife's relatives usually"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.27.1.0.box.271.391.1153.258.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.0.0"
    }
  }), _vm._v("\ndid. St. Denis called on him immediately. The meeting may have determined the immediate course of LouisianaTexas history. Both of these cultured men were probably starved for charming conversation, and over Bustillo's best wine and food they became fast friends.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.27.1.0.box.270.391.1156.1882.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.1.box.271.661.1153.369.q.70"
    }
  }, [_vm._v("Bustillo reported to the viceroy that trade existed with the French, mainly in such minor items as vegetables, but all was closely supervised, and that the surrounding Indians were well supplied with French guns and about everything else they wanted. In this light he subtly suggested to His Excellency that the French commandant was not an appropriate man to antagonize, about trade or anything else.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.2.box.270.1041.1154.844.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.2.0"
    }
  }), _vm._v("In this year of his arrival, the Natchez Indians were threatening to wipe out the Louisiana colony. After overrunning most of Louisiana, they attacked Natchitoches on October 5. A few hours later an excited horseman dashed up to the Spanish capitol on a sweat-soaked horse with an urgent message from St. Denis to the governor to seek aid. Bustillo might have thought of old scores to settle and reasoned that if the Natchez destroyed the French, it would be Spain's long-awaited opportunity to push across to the Mississippi, join Texas and Florida together, and make the Gulf of Mexico a Spanish sea. But this was an appeal from a friend, and he replied as such. He dispatched Spanish soldiers and a contingent of Indian allies to Louisiana, and for twenty-two days the two nationalities fought side by side. One Spanish soldier was killed. Louisiana was saved.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA18.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.27.1.3.box.270.1906.1156.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA18.w.1.3.0"
    }
  }), _vm._v("Bustillo was noted mostly for settling Canary Islanders in San Antonio in 1731, and personally leading a successful campaign against the Apaches in 1732 that brought temporary peace. Just when he ended his governorship is not certain; it was probably 1734. He became an "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alcalde ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ordinario ")]), _vm._v("of Mexico City, and in 1751 was a member of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Audtencia, ")]), _vm._v("the highest administrative and judicial body"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.28.1.0.box.275.403.271.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.0.0"
    }
  }), _vm._v("\nof New Spain.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.28.1.0.box.273.403.1154.262.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.1.1.box.273.458.1154.207.q.70"
    }
  }, [_vm._v("The frontier had done better than usual under Bustillo. Evidently his exercise of common sense, sometimes at variance with royal orders, and his friendship with the French commandant did him no political harm.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.28.2.0.box.271.786.1159.1508.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.28.2.0.box.539.786.620.97.q.80"
    }
  }, [_vm._v("MANUEL DE SANDOVAL "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1734-1736) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.1.box.273.949.1157.262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.1.0"
    }
  }), _vm._v("Manuel de Sandoval was commissioned governor of Texas in early 1734, and from then on he had little peace of mind. Even at fighting the Indians, his specialty, he had but limited success; and all the old problems of the eastern frontier rose up to haunt him, along with a few new ones.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.2.box.272.1221.1157.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.2.0"
    }
  }), _vm._v("A native of Santa Fe, New Mexico, he joined the army there and rose slowly, in twenty years from cadet to captain of the local grenadiers. He served as governor of Coahuila from 1727 to 1734. He came to Texas partly because the viceroy thought that as a military man he could put down the warring Apaches. But nobody at that time, it appears, could do that—at least not for long.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.3.box.271.1600.1155.522.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.3.0"
    }
  }), _vm._v("The Indians kept him occupied away from his capitol, from which he heard nothing but complaints. The whole establishment was rotting, the crops had failed, the main prospects for food were from the French, and they had raised their prices out of reach. Sandoval, because of age and weariness, may not have been as alert and as successful at personal defense as a younger and better-educated man might have been. But the way his luck was running, about every molehill of a mistake or reverse flared into a volcanic mountain.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA19.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.28.2.4.box.271.2143.1153.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA19.w.2.4.0"
    }
  }), _vm._v("As if the food problems, warring Indians, and tumbling-down capitol were not troubles enough for the absentee governor, the French chose this critical moment"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.29.1.0.box.270.390.1155.471.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.0.0"
    }
  }), _vm._v("\nto move their fort a short distance to the west, a mere few feet, but it definitely established the French on the west side of the Red River. Nothing in eighteenth-century Texas inspired as much writing. Sandoval, new in Texas and knowing no more than had recently been told him, set out to defend the Spanish side of the boundary dispute. St. Denis, who had been there long before there was a boundary, got the best of the argument. Both sides threatened war.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA20"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.29.1.0.box.270.390.1160.1885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.1.box.271.882.1155.528.q.60"
    }
  }, [_vm._v("Sandoval not only faced unsolvable problems, but he was a continued victim of ruinous timing of events. While caught between the warring Apaches and the \"invading\" French, and prodded by the viceroy to get things straightened out on both sides of his province, there appeared in Mexico City in 1736 one Carlos Franquis de Lugo with a commission from the king for the governorship of Tlaxcala. But that office was filled, and Franquis had to be taken care of without delay. So in view of some bad reports on Sandoval, he was chosen as loser.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.2.box.273.1420.1156.529.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.2.0"
    }
  }), _vm._v("As soon as Franquis had his commission changed to the governorship of Texas, he stormed into the province and arrested Sandoval on sight without a warrant, and put him in stocks in front of his capitol for everybody to gape at. To humiliation, Franquis added charges of misconduct against Sandoval for not residing at Los Adaes, not keeping his books properly, reducing the missionaries, and conniving with the French. On the first charge he was fined five hundred pesos, though he was busy fighting the Indians beyond San Antonio at the time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA20.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.29.1.3.box.273.1964.1157.311.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA20.w.1.3.0"
    }
  }), _vm._v("There were countersuits, but in the end Sandoval was bankrupted and sent to prison. Official investigation of the Sandoval case and previous happenings in Texas filled seventy volumes. The material was used in later boundary negotiations between Spain, France, and the United States. Thomas Jefferson, among others, studied them in search of"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.30.1.0.box.279.403.781.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.0.0"
    }
  }), _vm._v("\nthe true western boundary of Louisiana.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA21"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.30.1.0.box.277.403.1156.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.1.1.box.277.458.1156.369.q.60"
    }
  }, [_vm._v("As might be surmised, politics was at the bottom of this whole troublesome business. In December, 1743, a new viceroy in favor of Sandoval exonerated him. He was released from prison and again given a position in the army, where he served until his death. He doubtless would have lived a much happier life if he had never left the army.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.30.2.0.box.270.948.1161.1345.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.30.2.0.box.474.948.755.97.q.80"
    }
  }, [_vm._v("CARLOS FRANQUIS DE LUGO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.1.0"
    }
  }), _vm._v("(1736-1737) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.2.1.box.276.1110.1151.142.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.2.0"
    }
  }), _vm._v("Carlos Franquis de Lugo might have realized his ambition to get rich in Texas if he had talked less, and taken his time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.2.2.box.270.1275.1161.805.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.3.0"
    }
  }), _vm._v("Born in the Canary Islands in 1691, obviously of people of little substance, he moved to Havana, Cuba, in early manhood, where he married Angela de Alarcon. He blew into Texas like a whirlwind in 1736 without formal announcement or showing his governor's commission, insulting, ignoring, and bulldozing officials on his hasty journey to the frontier to put Sandoval and the French in their places. If Sandoval had let the French push him around, he deserved what he was getting. He announced that he would not only put the French back on the \"right side\" of the Red River, but he might even run them all the way across the Mississippi if they trifled with him. He had heard that Governor Sandoval was a wealthy man, a point that interested him exceedingly. But instead of talking business, he arrested him on sight.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA21.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.30.2.3.box.272.2090.1153.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA21.w.2.4.0"
    }
  }), _vm._v("Like most smart alecks, Franquis did more talking than thinking. While he was loudly threatening and boasting, St. Denis quietly rode over from Natchitoches and told him the French were there to stay, just where they were, and"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.31.1.0.box.278.390.1150.358.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.0.0"
    }
  }), _vm._v("\nHis Excellency could save himself a lot of pains if he forgot all about the boundary. The country by now looked so poor that Franquis decided Sandoval had gotten his money somewhere else. Also there appeared no point to him in risking fortune and glory by tangling with a stubborn Frenchman over a fragment of land. He took the commandant's advice.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA22"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.31.1.0.box.271.390.1158.1814.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.1.box.276.771.1153.680.q.60"
    }
  }, [_vm._v("He thundered back into the interior, and turned his fiery, abusive energy to suppressing and making fun of the missionaries and minor civil officials. He had dreams of military grandeur, so he called for more troops to lead, telling how he would annihilate certain unconquerable tribes. But his dreams of military glory faded out at the more practical and safer idea that live Indians might be worth more to him than dead ones. Instead of putting them to the sword, he would put them to the plow. This could have a double advantage, he thought. He could use both the Indians and troops in productive enterprises—a type of reasoning that showed him not to be as stupid as some of his critics claimed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.2.box.272.1472.1155.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.2.0"
    }
  }), _vm._v("But enemies grew faster and thicker around him than crops and commerce. How much he made by exploiting the Indians and settlers is impossible to say, but certainly time robbed him of any great fortune, for on July 9, 1737, he was arrested for overbearing conduct. One historian said that in a little more than a year Franquis came to very nearly ruining the entire province, doing more harm than the continuing attacks of the implacable Apaches.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA22.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.31.1.3.box.271.1904.1155.300.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA22.w.1.3.0"
    }
  }), _vm._v("After a trial lasting several years, and lawsuits involving Sandoval, Franquis became an officer of the garrison of Vera Cruz and eventually saw service in the regiment of Savoya in Spain, where he died. Ever lacking in patience and tact, both his coveted riches and glory eluded him to the last.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA23"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.32.1.0.box.270.412.1157.1829.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.32.1.0.box.318.412.1062.97.q.60"
    }
  }, [_vm._v("JOSEPH FERNANDEZ DE JAUREGUI Y URRUTIA "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1737) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.1.box.272.571.1151.426.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.2.0"
    }
  }), _vm._v("Joseph Fernandez de Jauregui had an extraordinary title and function in Texas. On July 11, 1737, he was appointed governor extraordinary and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("visitador ")]), _vm._v("of Texas, and his chief assigned function was to investigate Franquis. At that time he was governor and captain general of Nuevo Leon. But with two ex-governors, Franquis and Sandoval, in a political dogfight, somebody was desperately needed to bring the province out of chaos.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.2.box.272.1007.1153.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.3.0"
    }
  }), _vm._v("The friendly mission Indians, exploited by Franquis, were running away. Thus the missionaries were virtually out of business, and defenseless, too, with the allied natives gone and the soldiers away fighting Apaches. There was nobody at home to fight or administer. It was as if Texas was in a runaway wagon with no hands on the reins.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.3.box.271.1335.1156.627.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.4.0"
    }
  }), _vm._v("Jauregui started his investigation in September. Day after day he listened to all kinds of charges, but one defender called Franquis \"noble, generous\" and said he was regarded \"like legendary heroes of antiquity, not as a mere man.\" Jauregui must have realized that the FranquisSandoval cloud would hang over the land for a long time, ultimately to fade like disturbing ghosts into the mist of opinion. He concluded his report to the viceroy by October 15, and appointed Don Prudencio de Orobio y Basterra in charge of government affairs. He gave as his reason for a hasty departure the need to put down an Indian uprising in Nuevo Leon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA23.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.32.1.4.box.270.1984.1152.257.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA23.w.1.5.0"
    }
  }), _vm._v("Doubtless Jauregui realized there was little he could do for Texas or the individuals concerned. He submitted reams of testimony, but higher officials and courts could take it from there. Like most other governors before him, he was glad to be gone.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.33.1.0.box.270.389.1158.1765.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.33.1.0.box.361.389.980.95.q.50"
    }
  }, [_vm._v("PRUDENCIO DE OROBIO Y BASTERRA "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("73 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("7-1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("741) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.1.box.270.551.1155.265.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.1.0"
    }
  }), _vm._v("Prudencio de Orobio y Basterra was one of the few businessmen appointed governor of Texas. Governor Jauregui hurriedly appointed him governor "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("about mid-October, 1737, so he could get back to his Indian fighting in Nuevo Leon.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.2.box.275.826.1151.369.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.2.0"
    }
  }), _vm._v("Because he was a vague character for a governor, we pick up Orobio's story mainly through footnotes to history. He seems to have at one time been commander at the La Bahia presidio, and "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alcalde ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("mayor ")]), _vm._v("of Parras, Coahuila. But mainly he was a businessman—a trader in Saltillo and owner of a cattle and horse ranch at presentday Mier.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.3.box.275.1208.1153.837.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.3.0"
    }
  }), _vm._v("As governor he appears to have attended to his own business, literally and figuratively, while Texas drifted. Seeming without grasp or initiative for concerted action, he authorized campaigns against the Apaches either prematurely or too late, missionary reports indicate, irritating the Apaches more than quelling them. He managed to conduct trade with the French in produce, but the settlers complained it was too little and not for the right items. When he heard that the French were trading on the lower Trinity, or maybe attempting settlement, he sent an expedition to find out. It got lost. Hearing of the French being up to something here and there in other parts of the province, he chased them as if they were a will-o'-the-wisp, until he decided they were merely trying to make a few pesos at trade—about like every other civilian in the woods.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA24.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.33.1.4.box.275.2068.1151.86.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA24.w.1.4.0"
    }
  }), _vm._v("His term was over by 1741. He left Texas just about as he found it.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA25"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.34.1.0.box.271.402.1157.1455.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.34.1.0.box.484.402.729.96.q.60"
    }
  }, [_vm._v("THOMAS FELIPE WINTUISEN "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("741-1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("743) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.1.box.271.565.1153.589.q.60"
    }
  }, [_vm._v("Thomas Felipe Wintuisen became governor of Texas in 1741. Because there seems to be no account of him in the military records, it is supposed he was a civilian. We know very little about him. Texas had become comparatively quiet during this period, so the records are relatively few. The officials at Mexico City obviously considered the eastern frontier relatively stabilized from the standpoints of boundaries and trade, though nothing was actually settled. The Indians were peaceful there—better this way, under control of the French, than out of control under their own attemped management.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.2.box.272.1165.1156.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.2.0"
    }
  }), _vm._v("The missionaries plodded on their slow, discouraging way, pleading for more protection and complaining of the natives' lack of enthusiasm for mission life, but ever ambitious and brimming full of faith to the point that they contended they could tame the Apaches with the story of Christ's love where the soldiers were failing with gunpowder. During Wintuisen's term the Apaches continued to raid San Antonio, and the Comanches appeared with warpaint in the north.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.1.3.box.272.1651.1151.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.1.3.0"
    }
  }), _vm._v("Nothing really worked during this period. All hands merely endured. In 1743 Wintuisen faded out of office as quietly and mysteriously as he had come in, and history books do not even carry his name.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.34.2.0.box.270.1978.1153.310.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.34.2.0.box.498.1978.693.94.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.0.0"
    }
  }), _vm._v("JUSTO BONEO Y MORALES "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.1.0"
    }
  }), _vm._v("(1743-1744) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA25.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.34.2.1.box.270.2136.1153.152.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA25.w.2.2.0"
    }
  }), _vm._v("Justo Boneo y Morales rode into office on the backlash of the old Franquis-Sandoval controversy. There seemed no end to it, for the mills of justice ground ex"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.35.1.0.box.275.391.819.45.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.0.0"
    }
  }), _vm._v("ceedingly finely and slowly in old Mexico.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.35.1.0.box.270.391.1161.1885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.1.box.270.446.1157.742.q.60"
    }
  }, [_vm._v("Boneo was of high rank, a knight of the Order of Santiago and a lieutenant colonel in the Spanish army. On July 15, 1740, he was ordered to investigate the boundary between the Spanish and French and the charges made by Franquis against Sandoval and the missionaries of Texas. Just when Boneo started his investigation and where he spent his time are not clear. He probably spent months pouring over the seventy volumes written specifically about the Franquis-Sandoval case and the related history of the province, probably in Mexico City. Then there were other innumerable documents, for just about everybody of any importance in the government, army, and church had written something about this complicated affair, from one side or the other.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.2.box.277.1210.1152.523.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.2.0"
    }
  }), _vm._v("On December 17, 1743, Boneo was at Los Adaes working on his investigation when he received his appointment as governor of Texas. News, like justice, took a slow course in those days—the viceroy had written the appointment a year and two days earlier. Boneo's investigation up to this time seems to have boiled down to the conclusion that it was impossible to determine from the evidence where the boundary should be between the Spanish and French. By this time no one could get any clear view of the proverbial forest for the ever-increasing details of trees.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.3.box.277.1744.1153.474.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.3.0"
    }
  }), _vm._v("He was not governor long enough to do much about anything on the frontier. Seemingly the most encouraging occurrence during his administration, from a Spanish viewpoint, was the death of St. Denis on June 11, 1744. Boneo and other Spanish dignitaries rode over from their Spanish capitol to Natchitoches to attend the funeral. A few days later Boneo reported the occurrence to the viceroy in language that said, in effect: \"St. Denis is dead now. Thank God, we can breathe easier.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA26.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.35.1.4.box.354.2233.1077.43.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA26.w.1.4.0"
    }
  }), _vm._v("If there were new prospects at St. Denis' death of a"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.36.1.0.box.271.402.1154.315.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA27.w.1.0.0"
    }
  }), _vm._v("\nshift to stronger Spanish influence and less French interference on the frontier, Boneo did not live to see it. He died in September, 1744, the labors of another career on the frontier merely adding repetitious bulk to the mounting pile of memorabilia that changed nothing significantly or gave much hope of it.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.36.1.0.box.271.402.1154.315.q.60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.36.2.0.box.270.836.1157.1450.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.36.2.0.box.484.836.735.97.q.50"
    }
  }, [_vm._v("FRANCISCO GARCIA LARIOS "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("744-1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("748) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.1.box.272.999.1155.634.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.2.0"
    }
  }), _vm._v("Francisco Garcia Larios became governor of Texas on the death of Justo Boneo y Morales in September, 1744. Little is known of his life before or after his governorship. Spain was becoming disillusioned and paying less attention to its governors and their situations in the Texas province. The province was a drain on the royal treasury and recognized by now as not likely to show a profit, at least not in the foreseeable future. The missionaries were bickering with the military and civil officials about how to handle the Indians—saving the Indian's soul while saving their own scalps. French traders appeared unstoppable among the Texas tribes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.2.box.271.1654.1156.420.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.3.0"
    }
  }), _vm._v("So Larios was mainly engaged in arguing with the missionaries, primarily about their proposed establishments on the San Xavier River, which he stubbornly contended were impractical and indefensible. The missionaries persuaded the viceroy they were right, and Larios lost the argument. But the controversy was the chief subject of the documents of his administration, and like most Texas colonial arguments, it lasted on and on.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA27.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.36.2.3.box.270.2083.1156.203.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA27.w.2.4.0"
    }
  }), _vm._v("In 1747 he proposed to explore personally the Gulf Coast as far south as the Rio Grande—among other objectives, it seems, to investigate possibilities of establishing settlements and to chase out any French traders he found"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.37.1.0.box.270.391.1153.206.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.0.0"
    }
  }), _vm._v("\ndoing business there. But in the end this was left to a subordinate, and like about everything else we know about Larios' administration, it boiled down to a lot of talk and spreading of ink, and little significant action.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA28"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.37.1.0.box.270.391.1153.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.1.1.box.271.607.1149.97.q.60"
    }
  }, [_vm._v("He is listed in some accounts as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("governor. Whatever his exact status, it was over by mid-1748.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.37.2.0.box.271.826.1155.1448.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.37.2.0.box.309.826.1081.97.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.0.0"
    }
  }), _vm._v("PEDRO DEL BARRIO JUNCO Y ESPRIELLA "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("748-1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("750) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.2.1.box.271.989.1154.527.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.1.0"
    }
  }), _vm._v("Just as it appeared affairs were getting dull and routine, Pedro del Barrio Junco y Espriella became governor and stirred up the Texas province like nothing else since the old Franquis-Sandoval mess. He was appointed governor "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("June 3, 1748. He immediately locked horns with the missionaries over their efforts to locate establishments on the San Xavier (San Gabriel) River. He, like Governor Larios, lost the argument, which seems to have done his temper no good when dealing with other people in Texas.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.2.2.box.271.1528.1154.463.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.2.0"
    }
  }), _vm._v("Barrio made more than one personal inspection and report of San Xavier to support his stand that the location was impractical and indefensible. He reported that the soldiers there were deeply discouraged over defeats by the Indians, who also stole their horses; in the rainy season the river overflowed, and in dry weather it dried up; the natives congregated there not to hear about Christ but for protection against the Apaches and for trade, including that with the French.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA28.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.37.2.3.box.271.2013.1155.261.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA28.w.2.3.0"
    }
  }), _vm._v("The missionaries went all the way to Mexico City to argue against the governor. Barrio, who was notable as a gambling man, wagered his head that the mission would not be maintained on the San Xavier. The missionaries, of course, never attempted to collect on such a wager, but"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.38.1.0.box.273.404.1156.143.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.0.0"
    }
  }), _vm._v("\nthey took advantage of a fitting figure of speech to proclaim that in their opinion the governor had already lost his head.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.38.1.0.box.271.404.1159.1885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.1.box.273.568.1157.372.q.60"
    }
  }, [_vm._v("When the viceroy went against him, he seems to have taken his superior's other judgments and decrees with as little respect. He lifted all bans on gambling and engaged in trade with the French. At least the missionaries said he did, and they finally got an investigation started against him, referred to in history books as the \"introduction of an unsavory chapter in Texas history.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.2.box.272.951.1156.369.q.60"
    }
  }, [_vm._v("Barrio brooked no support of the Xavier matter by his officials. When Toribio Urrutia, long-time captain of San Antonio, signed a document in this connection supporting the missionaries' stand, Barrio upbraided him sharply, saying he was more in need of his sword than his pen, and apparently sent him to jail to meditate over his \"insubordination and meddling.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.3.box.271.1331.1156.681.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.3.0"
    }
  }), _vm._v("One may wonder on casual observation why Barrio landed in Texas in a stew and stayed in it virtually the whole of his administration. He could hardly have been against the missionary program per se, for he had been the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("alcalde ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("provincial ")]), _vm._v("of the Santa Hermandad of all New Spain, a holy brotherhood; he had previous administrative experience, as governor of Neuvo Leon for six years; and he should have understood Indians (which may have caused in part his objection to San Xavier), for he had led numerous campaigns against them. As a military man he obviously had ability, when under control, for as late as March 27, 1765, he was appointed captain of Paso del Norte.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA29.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.38.1.4.box.271.2034.1154.255.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA29.w.1.4.0"
    }
  }), _vm._v("Obviously the overzealous set-in-their-way missionaries and minor officials irritated him, and he chose to stand like a mighty oak in the wind, too stiff to sway, and the storm broke him. He was removed from the governorship in late 1750—to the last, too stiff a timber to bend at all.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA30"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.39.1.0.box.271.392.1154.1883.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.39.1.0.box.390.392.917.97.q.70"
    }
  }, [_vm._v("JACINTO DE BARRIOS Y JAUREGUI "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.1.0"
    }
  }), _vm._v("(1751-1759) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.1.box.273.557.1151.366.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.2.0"
    }
  }), _vm._v("By the time Jacinto de Barrios y Jauregui was appointed governor and captain general of Texas in 1751, the power struggle between the missionaries and the governorship had become something of a tradition. The struggle had been intense and constant during his predecessor's administration, and the stage was set for him to continue the drama—which he did, from start to finish.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.2.box.273.939.1152.902.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.3.0"
    }
  }), _vm._v("The missionaries said Barrios knew too many intimate details about the missions, particularly San Xavier, for a stranger, that his opinions were fixed from talk with previous governors residing in Mexico City before he reached the province. By the time he arrived at his capitol at Los Adaes in June, he had left a long trail of irritated priests already buzzing about the inkpots eager to furnish complaints and opinions to their superiors. They even made some play on the similarity of his and his predecessor's name and character—that he was a Barrio in the plural. They wrote, among other things, that he had slighted the missionaries, made violent threats against them, planned to put the Indians to work for the Canary Islanders, was withdrawing military support, and had in particular abused Father Fray Joseph Pinilla \"in a manner unbecoming his birth and rank and the character of the religious,\" and so on and so on.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA30.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.39.1.3.box.271.1852.1152.423.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA30.w.1.4.0"
    }
  }), _vm._v("A military career man, Barrios had entered the service of the Spanish king about 1718 and rose from ensign to lieutenant colonel in campaigns against the Italians. He came to New Spain with a commission from the king. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(Ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("governors might be appointed by the viceroy.) A royal appointee such as Barrios was usually governor and captain general of his province and captain of the presidio of Los Adaes, the capital. In this capacity he exercised"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.40.1.0.box.283.402.638.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.0.0"
    }
  }), _vm._v("\nboth civil and military authority.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA31"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.40.1.0.box.276.402.1160.1884.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.1.box.281.456.1155.521.q.60"
    }
  }, [_vm._v("If we believe the reports of the missionaries, Barrios was one of the most corrupt of governors by virtue of his operating a monopoly of foreign trade. Certainly he did engage in trade, and probably made a modest fortune at it, particularly among the Orcoquiza and Bidai. He bought goods at Natchitoches, such as knives, scissors, even firearms, and transported them in pack trains under guard of soldiers and traded them for such items as deer and buffalo hides. He also sold to soldiers and civilians at Los Adaes and Saltillo.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.2.box.280.998.1154.862.q.60"
    }
  }, [_vm._v("Aside from his extensive business ventures, he had a hand in other notable occurrences—the founding of San Agustin de Ahumada, moving of the San Xavier missions and San Francisco Xavier presidio to the San Marcos River, recommending the expedition against the Apaches by Diego Ortiz Parilla, and founding of the mission of San Saba de la Santa Cruz and the San Saba presidio. And he, like most other governors of this period, was ordered to investigate the eastern boundary, which he did in 1753. He reported that the Red River was the true boundary, but testimony showed that since 1736 the Arroyo Hondo, about midway between Los Adaes and Natchitoches, was the accepted limit. He reported that the Spanish were at the mercy of the French, that in case of war (apparently thinking of the Indians) they could massacre all the Spanish.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA31.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.40.1.3.box.276.1870.1155.416.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA31.w.1.3.0"
    }
  }), _vm._v("He made efforts to keep the French out of the province, especially along the Trinity River—possibly both as an official duty and to keep down competition for his business. And like numerous other governors, he had mines to investigate. In 1755 reports abounded of silver mines in the Llano and upper Colorado regions, mountains of pure silver. One reporter stated that the mines of Cerro del Almagre were so numerous that he could guarantee a mine"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.41.1.0.box.271.388.1149.98.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.0.0"
    }
  }), _vm._v("\nfor each inhabitant in the entire province—as usual, much more exciting talk than precious metal.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA32"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.41.1.0.box.270.388.1154.575.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.1.box.270.496.1154.260.q.60"
    }
  }, [_vm._v("In mid-1756 Angel de Martos y Navarrete was appointed governor of Texas and Barrios governor of Coahuila, but the appointments were interchanged to permit Barrios to remain in Texas until 1759 to complete the founding of the presidio of San Agustin de Ahumada.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.1.2.box.271.767.1153.196.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.1.2.0"
    }
  }), _vm._v("Evidently neither his trade with the French nor the tattling of the missionaries did him any real political damage. After leaving Texas, Barrios served two terms as governor of Coahuila.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.41.2.0.box.271.1093.1156.1173.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.41.2.0.box.393.1093.909.95.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.0.0"
    }
  }), _vm._v("ANGEL DE MARTOS Y NAVARRETE "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("759-1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("766) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.1.box.271.1255.1154.691.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.1.0"
    }
  }), _vm._v("Angel de Martos y Navarrete might well be called the vagabond governor of Texas. He survived primarily, it seems, by virtue of uncanny luck and/or sufficient habitual inertia to let time take care of his problems, such as they were taken care of. His contemporaries complained that he lived like an Indian in his capital, letting both equipment and morale go to pot. He was accused, probably correctly, of making a profit of a thousand percent on illegal foreign goods sold to his garrison. He used the labor of the soldiers to operate his farm and stock ranch, and sanctioned a campaign against the northern Indians that resulted in a rout and a \"disgrace to Spanish arms.\" In the end he was found guilty of burning a town.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA32.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.41.2.2.box.271.1956.1156.310.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA32.w.2.2.0"
    }
  }), _vm._v("Martos was a naval lieutenant before receiving his royal commission as governor on August 26, 1756. Even in the beginning, time was kind to him, for his predecessor was allowed to remain in Texas to carry out some projects already under way. So Martos acted as governor of Coahuila until February 6, 1759, while some of the most"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.42.1.0.box.272.403.955.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.0.0"
    }
  }), _vm._v("\ntroublesome problems of Texas were diminished.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA33"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.42.1.0.box.270.403.1157.1891.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.1.box.271.456.1156.742.q.60"
    }
  }, [_vm._v("Actually, the disastrous campaign against the northern Indians led by Diego Ortiz Parilla was pretty well set by his predecessor. Martos merely nodded his approval, which was about as much action as he took on many official duties. His actions concerning location of missions on the lower Trinity are typical. He seems to have done as little as possible and let problems wait and fizzle out. Such was the handling of the proposed removal of Los Horconsitos. The governor changed his mind a time or two and ended up by asking the viceroy to relieve him of the responsibility. Typically, nothing was done. His conflicts with the missionaries were mild. He simply let them talk and wear the issues out without aggravating them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.2.box.271.1220.1155.644.q.60"
    }
  }, [_vm._v("In 1763 he got into a boundary dispute—doubtless pressed into it by his superiors—with Chevalier Macarty, commandant of Natchitoches, over the eastern boundary. He had the most troublesome of defenses on his hands, for Macarty claimed that by virtue of La Salle's colony, France had a valid claim to all territory lying east of a line running north of the Bay of San Louis. But Martos' luck was still holding. Already Louisiana had been ceded to Spain, though the cession of 1762 was not known on the border. So the boundary and contraband trade were beginning to lose their political significance, and time again temporarily settled the issues.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA33.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.42.1.3.box.270.1875.1156.419.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA33.w.1.3.0"
    }
  }), _vm._v("Martos' luck could not endure forever. In November, 1763, Rafael Martinez Pacheco was appointed commander of the San Agustin de Ahumada presidio. Charges against him by his troops brought Martos to the presidio to investigate. When Martos ordered the commander's arrest, he barricaded himself in the presidio, and a shoot-out resulted. After several days of a standoff, soldiers set fire to the presidio to rout out Pacheco. He escaped, and so, it"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.43.1.0.box.271.391.1155.370.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.0.0"
    }
  }), _vm._v("\nseems, did Martos' luck in the affair. Martos, accused of responsibility for burning the presidio, could not shake off the charge. In this instance, time did not work in his favor. In typical Spanish fashion, the investigation and trial dragged on for fourteen years. In the end he was found guilty and assessed a heavy fine, but by the end of 1766 it was all over for him as governor.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA34"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.43.1.0.box.271.391.1155.749.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.1.1.box.271.772.1153.368.q.60"
    }
  }, [_vm._v("This ruinous Pacheco affair seems out of character for Martos. He did not appear a violent man; he was always ready to sway rather than risk breaking. He had such a good thing going for him—enormously profitable trade and other personal enterprises—that it does not seem he would have risked rocking the political boat so recklessly. But time and luck eventually run out on all men.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.43.2.0.box.272.1261.1154.1010.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.43.2.0.box.658.1261.385.92.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.0.0"
    }
  }), _vm._v("HUGO OCONOR "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.1.0"
    }
  }), _vm._v("(1767-1770) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.2.1.box.273.1419.1152.368.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.2.0"
    }
  }), _vm._v("Hugo Oconor, unlike other governors up to his time, influenced major events in Texas before and after his administration. He was also different, in degree at least, from his recent predecessors—he was popular, dedicated to official duties, and possessed noticeable administrative ability. Yet circumstantial evidence indicates he may have been a man of far-reaching human weakness.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.2.2.box.272.1798.1154.419.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.3.0"
    }
  }), _vm._v("He was probably Irish by birth. His flaming red hair caused the Indians to call him the \"Red Captain.\" As inspector general for frontier Spain, he came to San Agustin to investigate the trouble between Governor Martos and Pacheco. The records indicate that Martos deserved to be fired as governor on general principles, but considering the manner of his firing, there is room to wonder about the purity of Oconor's motives.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA34.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.43.2.3.box.348.2229.1075.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA34.w.2.4.0"
    }
  }), _vm._v("It seems that Martos was not at San Agustin at the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.44.1.0.box.274.401.1156.532.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.0.0"
    }
  }), _vm._v("\ntime of the burning of the presidio, and that Marcos Ruiz, commander of government troops, was first arrested for the offense. Martos unfortunately had few personal assets in his favor for winning approval and respect. He was sloppy, careless, without poise, dull—no match for Oconor in such respects. Oconor, according to Governor Martos, arrived at San Agustin accompanied by a cousin of Pacheco; and primarily, if not entirely, on the basis of Oconor's investigation and report, he got Martos' job as governor in 1767.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.44.1.0.box.270.401.1160.1888.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.1.box.273.945.1154.264.q.70"
    }
  }, [_vm._v("Oconor's administration is described as efficient and energetic. He reorganized and strengthened the garrison at San Antonio, increased order in government in general, checked temporarily the ravages of the northern tribes, and chastised the raiding Apaches.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.2.box.270.1220.1157.1014.q.60"
    }
  }, [_vm._v("After leaving the governorship of Texas in 1770, he was promoted from the rank of sergeant major to colonel and in time became commandant inspector of the Internal Provinces. In this position Oconor still had the upper hand in Texas, and again there is reason to suspect human weakness showing through his official armor—which gets ahead of our story of governors. When the succession of 1762 became known, orders were sent out to abandon the presidios of East Texas, as they were no longer needed to guard a frontier. The Baron de Ripperda had become governor and listened to the petition of the settlers of Los Adaes to remain at their homes, and he so recommended. Oconor opposed. There was jealousy and hatred between the two men. Ripperda appealed to the viceroy over Oconor's head, pointing out that he was his senior in rank, age, and length of service, and asked if he had to obey him. Oconor heard about this, and the feud became bitter. Oconor even had Antonio Gil Ybarbo, leader of the Adaesians, imprisoned.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA35.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.44.1.3.box.345.2247.1078.42.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA35.w.1.3.0"
    }
  }), _vm._v("Certainly, from humane and practical standpoints,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.45.1.0.box.271.392.1151.151.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA36.w.1.0.0"
    }
  }), _vm._v("\nRipperda was in the right, and it was later officially so agreed. Oconor demonstrated that ability and dedication do not necessarily preclude self-interest and prejudice.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.45.1.0.box.271.392.1151.151.q.70"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.45.2.0.box.271.664.1155.1610.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.45.2.0.box.342.664.1003.151.q.70"
    }
  }, [_vm._v("JUAN MARIA VICENCIO DE RIPPERDA, BARON DE RIPPERDA "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.1.0"
    }
  }), _vm._v("(1770-1778) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.1.box.271.883.1155.582.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.2.0"
    }
  }), _vm._v("Baron de Ripperda was a romanticist. A native of Madrid and a nobleman, he grew up amid the excitement, finery, and comforts of the glittering capital of old Spain, where he heard talk of the ever-expanding empire. He in time dreamed of having a part in it—commanding armies, ruling loyal, obedient subjects, bringing civilization and Christianity to adoring simple natives in strange wilderness lands, and winning the admiration of his king. So in early 1769 he hit the glory trail for Texas to become governor. The stage was indeed set for high drama for this romantic, but it was all tragic drama.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.2.box.272.1476.1153.680.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.3.0"
    }
  }), _vm._v("The dashing baron had one final fling at gaiety in the New World. While waiting in Mexico City for the administration of Oconor to end, he fell in love with and married, on October 22, 1769, a beautiful heiress, Dona Mariana Gomez de Parada. In March of the following year the baron and his bride were in San Antonio, now the temporary capital. The best lodging they could find was an abandoned calaboose, and his capitol was a mere shack, \"in ruins.\" His orders for improvement brought no results. The citizens had little respect for governors, being mainly engrossed in saving their scalps from raiding Indians. In this dilapidated one-room jail, the young baroness gave birth to her first child.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA36.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.45.2.3.box.273.2177.1151.97.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA36.w.2.4.0"
    }
  }), _vm._v("Ripperda's chief concern was the Indians. He had to use threats to keep citizens from abandoning San Antonio"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.46.1.0.box.273.404.1154.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.0.0"
    }
  }), _vm._v("\nfrom fear of marauders. He called for reinforcements from other presidios, and this brought missionaries down on him from all sides, saying he was risking ruin to the mission system. Then fears of an English attack swept over the province.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA37"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.46.1.0.box.270.404.1159.1885.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.1.box.273.674.1156.587.q.70"
    }
  }, [_vm._v("In 1772 the capital of Texas was officially moved to San Antonio. The next year orders came to Ripperda to remove the East Texas establishments back into the interior, now that there was no frontier to guard. One might think that in the cession of Louisiana to Spain, the French would have felt the impact most. They did complain that their king had dealt lightly with them, but their miseries were light compared with those of the Spanish of East Texas, who wailed that they were being treated brutally by being removed. Los Adaes was the only home most of them knew, and many had married into French families.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.2.box.272.1273.1156.534.q.60"
    }
  }, [_vm._v("Governor Ripperda came to Los Adaes hoping he could prevent the abandonment, but Oconor opposed him and he went away in deep disappointment. The Adaesians were told to prepare to march in five days. The aged Lieutenant Governor Gonzales, on orders, rode through the streets with a whip in hand driving the people from their homes, a task that broke his heart. He died a few days later in Nacogdoches. This incident reminds one of the expulsion of the Acadians from Nova Scotia and their wanderings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA37.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.46.1.3.box.270.1817.1156.472.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA37.w.1.3.0"
    }
  }), _vm._v("The Adaesians died by the scores from hardships. Their leader, Antonio Gil Ybarbo, went to Mexico City, petitioning the viceroy to allow them to return to their homes. Only after six years of wandering were they permitted to return as close as Nacogdoches, where they made a permanent settlement, thus ending an illustrative episode in the fading glory of an out-worn system where the state came first and the people last, and bringing the curtain down on one of Texas' sorriest and most tragic dramas.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA38.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA38"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.47.1.0.box.271.389.1150.476.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.1.0.box.271.389.1150.476.q.60"
    }
  }, [_vm._v("One encouraging event in Ripperda's administration was the aid of Athanase de Mezieres in bringing the northern tribes under control. But Oconor beclouded even this by casting suspicion on the work and belittling it, saying the governor favored Frenchmen and engaged in illicit trade. As a result, the viceroy forbade Ripperda all communication with Louisiana, and removed him in 1778 for noncompliance. The disillusioned baron died in October, 1780, as governor of Honduras.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.47.2.0.box.270.985.1155.1281.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.47.2.0.box.594.985.504.96.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.0.0"
    }
  }), _vm._v("DOMINGO CABELLO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.1.0"
    }
  }), _vm._v("(1778-1786) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.1.box.271.1147.1149.205.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.2.0"
    }
  }), _vm._v("Domingo Cabello was a practical man of common sense. He was not lazy, but by often letting well enough alone he maintained better than usual relations with his people.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.2.box.272.1363.1153.312.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.3.0"
    }
  }), _vm._v("His record before coming to Texas may be described as efficient, though not brilliant. A native of Castile, Spain, he became a soldier by profession, rising to lieutenant by 1741. In 1762 he was appointed governor of Nicaragua in recognition of his bravery at Havana. He held the rank of colonel when he became governor of Texas in 1778.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.3.box.270.1686.1152.528.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.4.0"
    }
  }), _vm._v("Cabello listened with patience to the missionaries, was firm with them in his decisions, and in the main was respected by them. He attempted to make himself knowledgeable in detail about conditions in his province, and on September 30, 1784, he submitted a complete report to the commander general of the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Provihcias ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Internas. ")]), _vm._v("He took a census of the Texas missions in 1785, in 1786 he commissioned Pedro Vial to explore a direct route from San Antonio to Santa Fe, and he approved the permanent settlement of the Adaesians at Nacogdoches.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA38.w.2.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.47.2.4.box.347.2224.1074.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA38.w.2.5.0"
    }
  }), _vm._v("He emphatically declared the Indians could not be"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.48.1.0.box.272.401.1153.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.0.0"
    }
  }), _vm._v("\ntrusted. To him there was no such thing as a friendly Indian. Even those reared in the missions, Cabello said, would revert to original type. Those who received presents and were befriended by the Spanish would be friendly in proportion to the gifts and other advantages enjoyed by the recipients. He favored bringing the Indians under military subjection, but he faced the same problem the fabled mice did in their solution of belling the cat. A great, applauded idea, but who's for putting the bell on?")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA39"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.48.1.0.box.271.401.1154.687.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.1.1.box.271.891.1154.197.q.70"
    }
  }, [_vm._v("In November, 1786, Cabello was made "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("teniente ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Rey ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("de ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Havana. ")]), _vm._v("Except for the warring Indians, his administration might have been one of the most peaceful and routine.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.48.2.0.box.271.1220.1156.1069.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.48.2.0.box.466.1220.766.97.q.80"
    }
  }, [_vm._v("RAFAEL MARTINEZ PACHECO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1787-1790) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.1.box.272.1382.1154.422.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.1.0"
    }
  }), _vm._v("Rafael Martinez Pacheco was a political opportunist, mysterious and controversial, an apparent paradox. Most of the record is based on what he, or his enemies, said. Thus truth about him is elusive. He may have obtained the governorship by default (Bonavia Bernardo did not serve after being appointed because he was needed elsewhere) and his own indirect recommendation. He had the peculiar knack for effectively recommending himself.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA39.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.48.2.2.box.271.1815.1156.474.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA39.w.2.2.0"
    }
  }), _vm._v("In 1759 Pacheco petitioned the viceroy for a post in Texas. In listing his experience, he said he had helped Diego Parilla move the presidio of San Francisco Xavier from the San Marcos to the San Saba River in 1757, had recruited families to settle San Saba, and had served as conductor of supplies and horses for San Antonio. On November 23, 1763, he was appointed commandant of San Agustin. We have already seen how he was instrumental, with the involvement of governor-to-be Oconor,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.49.1.0.box.280.390.886.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.0.0"
    }
  }), _vm._v("\nin effecting the downfall of Governor Martos.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.49.1.0.box.280.390.1155.1882.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.1.box.280.443.1153.360.q.60"
    }
  }, [_vm._v("In the fall of 1769 he was responsible for delivery of a group of shipwrecked families from the Gulf Coast to Natchitoches. He was made commandant of La Bahia in 1770, and aided Ripperda in campaigns against the warring Indians. Pacheco literally put the mission Indians on welfare; as long as they had plenty of beef and corn, he didn't have to bother with them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.2.box.281.826.1153.478.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.2.0"
    }
  }), _vm._v("Pacheco praised the missionaries and pictured them as underdogs standing up against the governors. They reciprocated by singing his praises. They said he brought a physician to San Agustin at his own expense to treat soldiers and Indians alike, that \"aware of the effect of a good example he attended personally the evening services held in the mission and led the soldiers in prayer.\" \"He has literally taken his food from his mouth that the sick may not want,\" a priest reported.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.3.box.280.1314.1153.415.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.3.0"
    }
  }), _vm._v("He wrote lengthy suggestions for improvement of government in Texas, saying that the chief trouble had been incompetent governors and presidio commanders. Most had limited experience in dealing with natives, were blinded by selfish interest, and had failed to cooperate with the missionaries. And many governors had engaged in illicit trade. This analysis proved him an astute observer and an effective phrase-maker.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA40.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.49.1.4.box.281.1740.1154.532.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA40.w.1.4.0"
    }
  }), _vm._v("About the next thing we hear of Pacheco is that he was governor of Texas. His appointment was dated February 21, 1787. There is little reliable evidence to measure the governor's administration against his stated standards. In one of his own accounts to the viceroy, we see him as a man of decisive, vigorous action: Cornered in a room in San Antonio by hostile Lipans, he finally succeeded in \"unsheathing\" his sword and transfixed the Lipan chief with such a mighty thrust that it inflicted a skin wound on an Indian beyond the chief. The room was"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.50.1.0.box.270.402.1156.195.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.0.0"
    }
  }), _vm._v("\nsmeared with blood—on tables, chairs, walls, everything— a picture of supreme heroism with the governor standing stalwart with dripping sword in hand, master of his fate as well as Texas'.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA41"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.50.1.0.box.270.402.1156.1074.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.1.box.271.618.1154.370.q.70"
    }
  }, [_vm._v("No question about it, the governor had a blessed talent for any politician, that of never personally obscuring his role as a hero and champion of threatened humanity. He pleaded in behalf of the people that they be allowed to brand cattle on the open range and that the cattle not be declared property of the Crown. He got some minor concessions from the Crown and major applause from the people.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.1.2.box.271.998.1154.478.q.60"
    }
  }, [_vm._v("Pacheco was accused, in connection with Gil Ybarbo, of smuggling. His administration seems to have faded out into limbo. One historian said of this period that the office of governor seems to have been eliminated and the province of Texas administered by a presidial captain. Pacheco probably was ineffective for some time before the \"viceroy\" removed him October 18, 1790. Apparently opportunities in time ran out on him. His ending is as mysterious and veiled as his beginning.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.50.2.0.box.270.1596.1155.692.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.50.2.0.box.635.1596.424.96.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.0.0"
    }
  }), _vm._v("MANUEL MUNOZ "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("790-1 ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("799) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.2.1.box.271.1759.1154.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.1.0"
    }
  }), _vm._v("By the time Manuel Munoz became head of the province in 1790, the governorship, to a conspicuous extent, either killed or corrupted its holders, or both. It had become increasingly difficult to keep a good man in the governor's chair.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA41.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.50.2.2.box.270.2030.1155.258.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA41.w.2.2.0"
    }
  }), _vm._v("Reading Munoz' correspondence and reports, one would think his administration was about as routine as anyone could expect. That meant, in late eighteenth-century Texas, that there was endless, petty, dull red tape: the documents reveal in caricature a governor's role in provincial life. He"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.51.1.0.box.270.391.1155.694.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.0.0"
    }
  }), _vm._v("\nsupervised trade among Indians and colonials and investigated the age-old plague of illicit trade (it was still illegal to trade with the French in Louisiana). He heard arguments about how primary schoolteachers should be paid from the government treasury, or should parish priests do the teaching. He regulated Indian labor for construction and repair of churches and priests' quarters, and ruled that such labor required a permit from the commander general. He made decisions about the purchase of \"flour and wine . . . wax candles and altar linens for celebration of the Holy Sacrifice.\" He made decisions on secularization of mission Indians, checked mission and presidio accounts, and had a hand in locating mission and presidio sites.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA42"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.51.1.0.box.270.391.1158.1450.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.1.box.273.1094.1153.579.q.60"
    }
  }, [_vm._v("Nothing monumental. But by 1796 the old man had had as much as he wanted and more than he could endure. He asked to be relieved because of failing health. He waited for nearly a year before he received word that his request had been granted and he had been promoted to colonel in the royal armies. Antonio Cordero had been designated his successor, but emergencies prevented his coming to Texas. Then Jose Irigoyen arrived in New Spain with a blank commission for the first open governorship. He was tagged for Texas but then became sick. Months lengthened into years, and Munoz became an invalid, confined to bed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.1.2.box.274.1689.1154.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.1.2.0"
    }
  }), _vm._v("The chief way out of the governorship in those days was via death or scandal. Manuel Munoz went the way of death on July 27, 1799.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.51.2.0.box.272.1961.1156.367.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.51.2.0.box.452.1961.794.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.2.0.0"
    }
  }), _vm._v("JUAN BAUTISTA ELGUEZABAL "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1799-1805) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA42.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.51.2.1.box.272.2123.1156.205.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA42.w.2.1.0"
    }
  }), _vm._v("During Juan Bautista Elguezabal's administration, a new problem loomed on the eastern frontier, the eternal source of trouble of one kind or another for eighteenthcentury Texas governors. It was immigration, and it never"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.52.1.0.box.277.403.1155.424.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.0.0"
    }
  }), _vm._v("\nwent away as long as there was a Spanish Texas. If Elguezabal could have, in the fabled manner, stuck his finger into the dike and plugged it, the history of the Southwest doubdess would have been much different. But he, like his predecessor, was tired, ill from hardships, wavering in his decisions, and discouraged at wrestling with a problem that nobody really knew how to solve. Also like his predecessor, he was to wear out at his job unto death.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA43"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.52.1.0.box.270.403.1163.1824.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.1.box.276.839.1157.524.q.70"
    }
  }, [_vm._v("Spain ceded Louisiana back to France in 1800, and in 1803 France formally transferred Louisiana to the United States. Many Latins in Louisiana petitioned Spain for \"asylum\" in Texas, and the flattered Spaniards welcomed them. Americans came too. Immigration policy was set mainly from above Elguezabal, but with all his effort he could not hold back even the trickle of American filibusters he was ordered to stop. And the trickle became a flood of land hunters with plows, driving stock and carrying rifles in hand.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.2.box.276.1384.1157.358.q.60"
    }
  }, [_vm._v("Elguezabal was born in 1741, became inspector of presidios of Coahuila and Texas in 1 795, and with the rank of captain, made detailed inspections of La Bahia and Rosario in 1797. He assisted Governor Martos during his incapacitating illness, thus performing many duties of governor until he became governor "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("on July 27, 1799.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA43.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.52.1.3.box.270.1763.1160.464.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA43.w.1.3.0"
    }
  }), _vm._v("In early 1799 he had issued a proclamation against introduction of merchandise from Louisiana. But by 1803 he said that it was futile to try to enforce it. The AlabamaCoushatta and Choctaw Indians were brought into Texas against his sanction and settled east of the Trinity River. He thought all Indians fickle and insisted that they be kept under supervision of experienced missionaries of mature judgment. He died in office in San Antonio in October, 1805.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.53.1.0.box.271.391.1156.1876.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.53.1.0.box.333.391.1030.96.q.80"
    }
  }, [_vm._v("MANUEL ANTONIO CORDERO Y BUSTAMANTE "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1805-1808) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.1.box.272.554.1155.477.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.1.0"
    }
  }), _vm._v("Manuel Antonio Cordero y Bustamante not only had an immigration problem in reverse to the old one (he, in time, wanted immigrants), but he had an outlaw empire as well on the eastern border. He became administrator of Texas in October, 1805, at the death of Elguezabal. He was, at the time, probably on his way to Nacogdoches at the head of troops to help defend the eastern frontier, for Spain and the United States (now the owner of Louisiana) were threatening war over the Louisiana boundary.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.2.box.271.1042.1156.571.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.2.0"
    }
  }), _vm._v("Cordero did not have to use his troops on the eastern border. War was averted by declaring the disputed territory between the Sabine and the Arroyo Hondo neutral in the fall of 1806. The arrangement prevented a war, but it caused no end of lesser troubles. Outlaws and the riffraff of the earth came pouring into this no-man's-land where no law existed. Naturally they spilled out at times into Texas, and they made travel extremely hazardous in crossing the zone. Efforts toward pursuing criminals into the strip or trying to police it brought warnings from the other side.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.3.box.272.1635.1154.475.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.3.0"
    }
  }), _vm._v("Cordero encouraged immigration as one of the most effective ways of building up a buffer against an aggressive and enterprising United States. This would serve his second plan, to build up a strong military force in Texas. Additional colonists could produce the additional supplies to support additional troops. He sent out invitations for immigrants, particularly craftsmen, and proved a prophet by theorizing that the Americans would be coming sooner or later, one way or another.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA44.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.53.1.4.box.271.2122.1154.145.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA44.w.1.4.0"
    }
  }), _vm._v("Cordero was an experienced frontier official. He was a lieutenant colonel in the Spanish army, and governor "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("of Coahuila from March 26, 1797, until December,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.54.1.0.box.273.403.1156.361.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.0.0"
    }
  }), _vm._v("\n1798, when he was appointed governor, a position he held with various interruptions until 1817. He was appointed successor to Governor Munoz but was unable to serve because he was leading a campaign against the Apaches. In early summer of 1805 he was appointed assistant governor of Texas because of the incapacitating illness of Elguezabal and the threat of war.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA45"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.54.1.0.box.273.403.1156.1350.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.1.box.273.784.1154.479.q.60"
    }
  }, [_vm._v("He encouraged friendly relations with the Indians as allies in defending the boundaries of Texas, and established the first hospital in Texas in 1806, mainly for soldiers. On April 24, 1807, Manuel Maria de Salcedo was appointed governor of Texas, arriving there in the summer of 1808. Cordero was directed to remain in the province to aid and instruct the new governor in his duties, which he did until 1810 when he returned to Coahuila, where he remained as governor until 1817.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.1.2.box.273.1272.1155.481.q.60"
    }
  }, [_vm._v("Cordero was the frontier troubleshooter of this period. He was called from the governorship of Coahuila to administer Texas when it hung in the balance, to strengthen and militarily defend its borders, in general to set policy that would hold it secure for Spain, and in the end to prepare his successor to keep up the effort. It was all futile in the end, but he probably did as well as anyone available could have done. He was dealing with forces inevitably building up beyond any individual human control.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.54.2.0.box.271.1873.1155.416.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.54.2.0.box.465.1873.769.96.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.0.0"
    }
  }), _vm._v("MANUEL MARIA DE SALCEDO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1808-1813) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA45.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.54.2.1.box.271.2032.1155.257.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA45.w.2.1.0"
    }
  }), _vm._v("Manuel Maria de Salcedo was a fatal victim of the conditions and circumstances he pleaded and worked against. He possessed an unusual viewpoint of Texas, for he had lived across the border in Spanish Louisiana, where his father was governor, and had moved back to Spain with"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.55.1.0.box.273.389.504.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.0.0"
    }
  }), _vm._v("\nthe family as late as 1803.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA46"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.55.1.0.box.270.389.1156.1877.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.1.box.271.443.1153.531.q.60"
    }
  }, [_vm._v("He was appointed governor of Texas on October 24, 1807, and took the oath of office that day in Cadiz. Arriving in Texas in the summer of 1808, he found the province a steam boiler under heavy pressure, agitating within by blind, blundering political intrigue and heated from the outside by restless American firebrands who thought Texas, and maybe all Mexico, should be a democracy like the United States. Actually, it seems, nobody knew precisely what he wanted, or how to go about getting what was needed.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.2.box.271.983.1151.410.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.2.0"
    }
  }), _vm._v("Salcedo pleaded for more colonization as a safeguard against encroachment. He suggested immigration from Louisiana as more convenient and economical than from Spain. He pleaded for a port on the Gulf Coast to liberalize trade and rapidly develop the province, and urged development of resources to make the province self-sufficient. He failed, however, to convince his superiors of the dangers around them.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.3.box.270.1414.1156.690.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.3.0"
    }
  }), _vm._v("Salcedo tried little and big things on his own to the limit of his authority. He proposed driving the freebooters from the neutral zone. Impossible. With revolution brewing he proclaimed some strange, tedious laws—anything that might help. He proclaimed a curfew requiring all persons to halt when called on or risk being shot. Husbands were held accountable for wives out late. Shooting and shouting in San Antonio were prohibited as being bad for the nerves. Burning trash was forbidden because it might be used as signals for Indians. Dancing required a permit and was permitted only in a \"house of good repute.\" Professional gambling and carrying of firearms were prohibited.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA46.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.55.1.4.box.270.2115.1153.151.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA46.w.1.4.0"
    }
  }), _vm._v("Without support from above, Salcedo was merely blowing against the wind. In 1810 revolution broke out in Mexico against centuries of callous, tyrannical gov"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.56.1.0.box.274.404.1153.140.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.0.0"
    }
  }), _vm._v("eminent. Salcedo was overthrown by the Casas revolution in January, 1811, but was restored later that year as the result of a counterrevolution.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA47"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.56.1.0.box.270.404.1160.1776.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.1.box.273.564.1157.797.q.60"
    }
  }, [_vm._v("But the worst was yet to come from the outside. In 1811 Jose Bernardo Maximiliano Gutierrez de Lara, a blacksmith turned diplomat, went to Washington, D.C., seeking military support for the Mexican revolutionists. Failing there, he prevailed upon a young West Point graduate, Augustus William Magee, stationed at the United States Army post at Natchitoches, to lead an army of liberation into Texas. Magee recruited and mobilized his \"Republican Army of the North\" mainly in the neutral zone. It was probably as motley a collection as ever marched under one banner: desperadoes from the neutral zone, Creoles from the southern parishes, Indians from the wilderness, soldiers of fortune from everywhere, Americans from the four corners of the nation, Republican Mexicans from the native soil.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.2.box.270.1383.1160.575.q.60"
    }
  }, [_vm._v("Salcedo and his Royalists fought a long retreat to San Antonio. His forces were finally defeated in the battle of Rosalis on March 19, 1813, and he and his staff surrendered as prisoners of war. Magee had died and Gutierrez was in charge. He was tyrannical and vengeful in the extreme. Members of the captured Royalist government, including Salcedo, were marched away, their throats cut, and their bodies left for the buzzards and coyotes to devour. Such Mexican cruelty and vengeance caused many Americans to desert, and the Republican Army of the North was later defeated. But it was too late for Salcedo.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA47.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.56.1.3.box.270.1978.1155.202.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA47.w.1.3.0"
    }
  }), _vm._v("The boiler had blown up from the effects of more patriotic fire than there were judgment and tolerance to control it. Salcedo was the victim of immature minds playing with the complexities of democracy.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.57.1.0.box.270.386.1161.1881.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.57.1.0.box.437.386.822.97.q.70"
    }
  }, [_vm._v("JUAN BAUTISTA DE LAS CASAS "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1811) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.1.box.275.549.1152.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.1.0"
    }
  }), _vm._v("Juan Bautista de las Casas had the golden opportunity to become the father of independence in Texas. Instead, he muffed his chance by becoming a despot.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.2.box.271.711.1159.467.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.2.0"
    }
  }), _vm._v("When Hidalgo started a revolution in the interior of Mexico against despotism in 1810, many liberty lovers of Texas followed suit. On the night of January 21, 1811, opponents of the government effected a coup d'etat in San Antonio, with Casas as leader. At dawn the next morning, just as reveille was sounded, Casas and his supporters marched briskly to military headquarters and took over the troops, then placed Governor Manuel Salcedo under arrest.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.3.box.277.1199.1154.474.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.3.0"
    }
  }), _vm._v("About the only clear-cut issue in this revolution was that the present government was corrupt and the only means for getting a change was revolt. Outside of that, it was motivated by a strange muddle of ideas and issues. Independence was not generally sought; the Revolutionists, in the beginning, declared themselves for the king, a stand confusing to some of their brethren in the interior. But almost everybody was confused in those days.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA48.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.57.1.4.box.270.1686.1161.581.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA48.w.1.4.0"
    }
  }), _vm._v("Juan Bautista de las Casas was a retired army captain. His long hitch of soldiering had been primarily a monotonous routine of garrison duty, carrying out petty orders of his superiors while he rose slowly in the ranks. Nothing exciting or momentous had occurred to give him an opportunity to write his name on the pages of history. He still had dreams of conquest, of victory on the battlefield, of promotion and acclaim. But with retirement his military career was seemingly finished, and he was only a captain, just another name on the long military roster. Now with a revolution started, he had a feeling that his hour had come."), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.58.1.0.box.276.401.1154.156.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.0.0"
    }
  }), _vm._v("\nHe knew little of what the commotion was about, but to him it had the rumble of a bandwagon upon which he might ride to glory.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA49"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.58.1.0.box.271.401.1161.1889.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.1.box.276.566.1155.482.q.60"
    }
  }, [_vm._v("Casas plunged into his administration with great energy. By nine o'clock of the first day of the revolution, he had freed the political prisoners in the guardhouse, and had ordered the arrest of all European-born Spaniards and the confiscation of their property. Before the day ended, he dispatched mounted troops to Nacogdoches and La Bahia to proclaim the new order there and to arrest the commanders and any others who refused to recognize him as governor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.2.box.271.1059.1161.583.q.60"
    }
  }, [_vm._v("Within two weeks the old government of Spain was overthrown and Texas was freed of the Spanish Royalists. Jose Mariano Jimenez, Hidalgo's colleague, sent Casas an appointment as governor. Then the revolution suffered defeats in Mexico, and dissension broke out among the leaders. By this time Casas was no argument for the cause. His lone-handed rule, lack of tact, severe treatment of opponents, and abuse of power turned fiery Revolutionists lukewarm and set Royalists to plotting his downfall. If this was liberty, then many former enthusiastic Revolutionists were not sure they wanted it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.3.box.272.1654.1157.313.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.3.0"
    }
  }), _vm._v("Royalists and disappointed Revolutionists joined forces and started a revolution within a revolution. Most people did not understand the meaning of the words \"liberty\" and \"democracy.\" They now considered any change better than what Casas was providing. Under Salcedo they at least had peace.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA49.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.58.1.4.box.271.1979.1157.311.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA49.w.1.4.0"
    }
  }), _vm._v("So on the night of March 1, another government for Texas was formed, and at dawn another leader, Juan Manuel Zambrano, took command of the troops at reveille and arrested the governor. A court martial in Monclova quickly found Casas guilty of treason, and on August 3, in compliance with his sentence, he was shot"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.59.1.0.box.270.390.1152.262.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.0.0"
    }
  }), _vm._v("\nin the back as a traitor. His head was cut off, put in a box, and sent back to San Antonio. Here, where he had enjoyed the prestige and dignity of being first officer of the land, his skull was stuck up on a pole in the middle of the Military Plaza.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.59.1.0.box.270.390.1152.536.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.59.1.1.box.271.662.1151.264.q.60"
    }
  }, [_vm._v("If Casus' head had not swollen so with power, his likeness someday might have been carved in marble instead of his head ending up bleaching in the sun on a pole before the eyes of his one-time followers. And freedom for Texas might have come sooner.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.59.2.0.box.272.1097.1154.1178.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.59.2.0.box.536.1097.628.97.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.0.0"
    }
  }), _vm._v("CRISTOBAL DOMINGUEZ "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1813-1814) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.59.2.1.box.273.1259.1153.365.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.1.0"
    }
  }), _vm._v("Cristobal Dominguez inherited the wreckage of the revolution, a revolution that produced nothing but hatred and division, that started out reasonably orderly and promising and ended in petty intrigues and bloody cruelty. It was not a big revolution as revolutions go, but the province was never the same afterwards—mistrust, instability, and property loss took a crippling toll.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.59.2.2.box.272.1634.1154.533.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.2.0"
    }
  }), _vm._v("With Salcedo killed, Jose Arredondo, commandant general of Eastern Interior Provinces, appointed Dominquez governor, subject to approval of the viceroy, sometime before August 26,1813. Republicanism had been suppressed, American aid cut off, and royal authority restored; but the country was in shambles. Over a thousand terrified colonists and Indians had fled to the neutral zone in Louisiana, homes were abandoned, farms and herds left unattended, and the jails were bulging with prisoners. The dire prophecies of Salcedo had come true.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA50.w.2.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.59.2.3.box.274.2179.1150.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA50.w.2.3.0"
    }
  }), _vm._v("Dominguez was instructed to reorganize the province and restore order and confidence in the new regime. He set"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.60.1.0.box.274.404.1156.590.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.0.0"
    }
  }), _vm._v("\nout to do the best he could. He tried to be firm with insurgent prisoners and their sympathizers, and warned against disloyalty. But his firmness had to be tempered for survival. Food and supplies were critically short. Workers were urgently needed. So he issued a proclamation of amnesty in October, 1813, granting a conditional pardon to those who had fled. Recognizing the need of the Indians' friendship, he made concessions to them such as reestablishing the trading post at Nacogdoches. He worked feverishly toward getting supplies from the interior—barely in time to avert panic.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA51"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.60.1.0.box.270.404.1160.1515.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.60.1.1.box.273.1005.1156.629.q.60"
    }
  }, [_vm._v("Dominguez had extensive administrative experience. He was adjutant inspector of presidios for Coahuila and Texas when he was ordered to Nacogdoches on November 26, 1810, by Governor Salcedo. With the outbreak of the Casas revolution, he was arrested for his loyalty to the Spanish government, but he escaped and fled to Natchitoches. He returned to Nacogdoches after the overthrow of Casas and took over the duties of lieutenant governor until September 20, when he became inspector of presidios. He then held the rank of lieutenant colonel. Shortly after Dominguez became governor, Arredondo appointed him his second in command.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.60.1.2.box.270.1656.1157.263.q.60"
    }
  }, [_vm._v("Dominguez doubtless did the best he could amid the chaos, which like the efforts of some other Texas governors was not enough. Also like numerous other governors, he wore out on the job and died in October, 1814, tired, discouraged, and old beyond his years.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.60.2.0.box.347.2037.1077.257.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.60.2.0.box.348.2037.1006.149.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.2.0.0"
    }
  }), _vm._v("BENITO ARMINAN, MARIA"), _c('a', {
    attrs: {
      "id": "GBS.PA51.w.2.1.0"
    }
  }), _vm._v("NO VARELA, IGNACIO PEREZ, MANUEL PARDO "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.2.2.0"
    }
  }), _vm._v("(1814-1817) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA51.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.60.2.1.box.347.2251.1077.43.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA51.w.2.3.0"
    }
  }), _vm._v("During the time of struggle for Mexican independence,"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.61.1.0.box.271.392.1155.197.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.0.0"
    }
  }), _vm._v("\nrecords are incomplete, and when available, often contradictory and otherwise confusing. We can do little more than list the chief executives during this chaotic period of transition.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA52"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.61.1.0.box.271.392.1156.1279.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.1.box.273.611.1154.416.q.60"
    }
  }, [_vm._v("Benito Arminan was appointed acting governor in 1814, following Dominguez, and served in that capacity until July 19, 1815, when he was permitted at his request to retire on account of failing health. He occupied himself mainly with the effort of securing basic necessities, including drugs, to keep his impoverished subjects alive. He kept an eye on marauding Indians and filibusters, but that was about all he could do.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.2.box.273.1049.1151.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.2.0"
    }
  }), _vm._v("Mariano Varela probably set a record for the shortest term. He served one week in July, 1815.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.3.box.271.1158.1154.255.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.3.0"
    }
  }), _vm._v("Lieutenant Colonel Ignacio Perez next served as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("governor, pending the arrival of Colonel Manuel Pardo. Perez is better known for his success as an Indian fighter, and for opposing the Long expedition and taking Long prisoners, than as governor.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.1.4.box.273.1422.1153.249.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.1.4.0"
    }
  }), _vm._v("Manuel Pardo took over as "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("governor in early 1817 and served for a few weeks. He was born in Santander, Spain, in 1774, and fought in the European wars. After Texas, he served as governor of Coahuila and as a soldier in Mexico.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.61.2.0.box.271.1802.1155.475.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.61.2.0.box.487.1802.728.95.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.0.0"
    }
  }), _vm._v("ANTONIO MARIA MARTINEZ "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1817-1822) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA52.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.61.2.1.box.271.1964.1155.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA52.w.2.1.0"
    }
  }), _vm._v("Antonio Maria Martinez had the sad duty of presiding over the collapse of the Spanish empire in Texas. He was the last governor of the Spanish regime in the province. Revolution had gnawed away at this remote corner of the empire until by 1821 it was all over and Mexico was an independent nation.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA53.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA53"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.62.1.0.box.301.404.1157.1460.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.0.box.301.404.1157.753.q.60"
    }
  }, [_vm._v("Martinez assumed the governorship in the spring of 1817. Nearly a decade of warfare had made Texas a \"desert.\" Invaders came, fled when attacked, then came again. With his limited forces and supplies, Martinez could see little hope for defense. The treasury was empty, the Indians were out of control, foreigners could not be stopped on the border. For defense he had only about three hundred \"pickets from the provinces\" with little clothing, food, or military equipment. The governor reported that he doubted he could muster enough men to spike the common at San Antonio if necessary. Expeditions against invaders were possible only because men and supplies were sometimes furnished from the interior provinces.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.1.box.302.1168.1155.368.q.60"
    }
  }, [_vm._v("Martinez was born in Andujar, province of Jaen, Spain. He enlisted in the military service July 7, 1785, and won the Cross of Northern Europe and the Cross of Germany on European battlefields. Texas was a pitiful climax for such a distinguished career. The old veteran could only appeal for supplies and men and watch helplessly as the empire he had fought for so valiantly crumbled about him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.1.2.box.301.1547.1154.317.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.1.2.0"
    }
  }), _vm._v("In the summer of 1821 he was forced to issue orders requesting the oath of allegiance to Agustin de Iturbide, soon to become emperor of Mexico. Martinez was replaced in the summer of 1822, and moved back to Mexico to die a few months later, like many of his predecessors, discouraged and exhausted, in relative obscurity.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.62.2.0.box.299.1985.1155.309.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    attrs: {
      "id": "para.62.2.0.box.517.1985.718.93.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.2.0.0"
    }
  }), _vm._v("JOSE FELIX TRESPALACIOS "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.2.1.0"
    }
  }), _vm._v("(1822-1823) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA53.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.62.2.1.box.299.2142.1155.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA53.w.2.2.0"
    }
  }), _vm._v("Jose Felix Trespalacios was a professional revolutionist who experienced its extreme hazard, the death sentence, and its ultimate glory, independence for his country along"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.63.1.0.box.276.390.1151.314.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA54.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.0.0"
    }
  }), _vm._v("\nwith personal recognition and reward. He was born in Coahuila, where he joined the militia in 1810. By 1814 he was sufficient revolutionist to be sentenced to death for conspiracy to provoke a rebellion in the interior provinces. His sentence was commuted to ten years in prison, but on the way to prison he escaped and again joined rebel forces.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA54"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.63.1.0.box.271.390.1156.1283.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.1.box.271.714.1154.422.q.60"
    }
  }, [_vm._v("In battle against the Royalists he was again captured, and again escaped. This time he went to New Orleans, and with the aid of local merchants organized an expedition to aid the independence movement. He joined forces with James Long, declared for the plan of Iguala (independence of Mexico), and was again imprisoned. He was released by the Iturbide government, and in late 1821, after independence, helped secure the release of Long and his followers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.2.box.276.1147.1149.192.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.2.0"
    }
  }), _vm._v("He was appointed governor of Texas on August 17, 1822, and served until his resignation on April 7, 1823. Under his administration, the Stephen F. Austin colony was divided into the Colorado and Brazos districts.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.1.3.box.275.1360.1151.313.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.1.3.0"
    }
  }), _vm._v("He served as senator from Coahuila to the Mexican National Congress from 1831 to 1833, then went back to soldiering until his resignation, December 15, 1834. He died at Allende, Chihuahua, on August 4, 1835. No governor had lived more dangerously, or seen more of the worst and best of revolution and independence.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.63.2.0.box.270.1794.1158.476.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.63.2.0.box.624.1794.454.96.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.0.0"
    }
  }), _vm._v("LUCIANO GARCIA "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("(1823) ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.2.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.2.1.box.270.1956.1158.259.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.1.0"
    }
  }), _vm._v("Luciano Garcia was appointed "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("ad ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("interim ")]), _vm._v("governor of Texas on June 16, 1823, assumed duties of the office on July 8, and served in that capacity until October 12, 1823, at which time he became commandant general of the province.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA54.w.2.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.63.2.2.box.349.2228.1076.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA54.w.2.2.0"
    }
  }), _vm._v("The provinces of Texas and Coahuila were joined as"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.64.1.0.box.272.406.1152.427.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA55.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA55.w.1.0.0"
    }
  }), _vm._v("\none state by decree of the Mexican Congress on May 5, 1824, with the provision that Texas was to be administered by a political chief. Garcia was appointed the political chief. He was friendly to the Austin colony, and completed its governing system by appointing the Baron de Bastrop as commissioner to extend land titles. He called the first elections in 1823 for the Texas representatives to the Constituent Congress of Mexico.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.1.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA55.w.1.2.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA55"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.64.1.0.box.271.406.1153.966.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.1.box.271.843.1153.313.q.60"
    }
  }, [_vm._v("We are not entirely sure about administrators, titles, and dates during this period of sudden changes, but Garcia retired from the political scene in Texas sometime in 1826. And about this time he received a discharge as lieutenant colonel from the military, and devoted himself to stock raising.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA55.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.64.1.2.box.271.1166.1152.206.q.60"
    }
  }, [_vm._v("After Garcia, Texas governmental affairs seem to have been handled, for a time, by political chief Antoni"), _c('a', {
    attrs: {
      "id": "GBS.PA56"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA56.w.0.0.0"
    }
  }), _vm._v("o Saucedo. Garcia was the last chief executive of Texas before it and Coahuila were joined as one state.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA56.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96932330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0007.vue
// module id = 63
// module chunks = 0